import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminSolar_connectionsSolax_inverters = z.any()
export type TagsGetAdminSolar_connectionsSolax_inverters = z.infer<typeof tagsGetAdminSolar_connectionsSolax_inverters>

export const paramsGetAdminSolar_connectionsSolax_inverters = z.object({})
export type ParamsGetAdminSolar_connectionsSolax_inverters = z.infer<typeof paramsGetAdminSolar_connectionsSolax_inverters>

export const querystringGetAdminSolar_connectionsSolax_inverters = z.object({ "municipalityId": z.string().uuid(), "businessType": z.union([z.literal(1), z.literal(4)]).optional(), "applicationId": z.string().uuid().optional() })
export type QuerystringGetAdminSolar_connectionsSolax_inverters = z.infer<typeof querystringGetAdminSolar_connectionsSolax_inverters>

export const responseGetAdminSolar_connectionsSolax_inverters = z.object({ "payload": z.object({ "inverters": z.array(z.object({ "deviceSn": z.string(), "deviceModel": z.union([z.string(), z.null()]), "plantName": z.union([z.string(), z.null()]), "plantId": z.union([z.string(), z.null()]), "onlineStatus": z.union([z.string(), z.null()]) })), "truncated": z.boolean(), "issues": z.array(z.object({ "code": z.string(), "retryAt": z.union([z.string().datetime({ offset: true }), z.null()]) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminSolar_connectionsSolax_inverters = z.infer<typeof responseGetAdminSolar_connectionsSolax_inverters>

interface IGetAdminSolar_connectionsSolax_inverters extends BaseMethodType {
  tags: TagsGetAdminSolar_connectionsSolax_inverters,
  params: ParamsGetAdminSolar_connectionsSolax_inverters,
  querystring: QuerystringGetAdminSolar_connectionsSolax_inverters,
  response: ResponseGetAdminSolar_connectionsSolax_inverters
}
export const URL = '/admin/solar-connections/solax-inverters'
export const validation = {
  get: {
    tags: tagsGetAdminSolar_connectionsSolax_inverters,
    params: paramsGetAdminSolar_connectionsSolax_inverters,
    querystring: querystringGetAdminSolar_connectionsSolax_inverters,
    response: responseGetAdminSolar_connectionsSolax_inverters
  }
}
export interface AdminSolar_connectionsSolax_inverters extends BaseRouteType {
  get: IGetAdminSolar_connectionsSolax_inverters
}